var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaBauvorhaben(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#c7cfe2;}.cls-3{fill:#59667c;}.cls-4{fill:#798395;}.cls-5{fill:#7a8596;}.cls-6{fill:#ed732d;}.cls-7{fill:#ea5c0b;}.cls-8{fill:#c1e2fa;}.cls-9{fill:#51aef0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.35,101.91a4.7,4.7,0,0,1-4.7-4.69V69A4.7,4.7,0,0,1,141,69V97.22A4.69,4.69,0,0,1,136.35,101.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.35,120.7a14,14,0,0,1-10-4.13,4.7,4.7,0,0,1,6.64-6.64,4.82,4.82,0,0,0,6.64,0,4.7,4.7,0,0,0-3.32-8,4.7,4.7,0,1,1,0-9.39,14.09,14.09,0,0,1,0,28.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.74,73.74a4.68,4.68,0,0,1-3.32-1.38L117.57,47.51,92.71,72.36a4.7,4.7,0,0,1-6.64-6.64l28.18-28.17a4.7,4.7,0,0,1,6.64,0l28.17,28.17a4.7,4.7,0,0,1-3.32,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.3,122.26a4.69,4.69,0,0,1-2.09,3.91L56.52,137.29,45,145a4.61,4.61,0,0,1-2.6.78,4.7,4.7,0,0,1-2.59-8.61L56.52,126l5.64-3.76-5.64-3.76L39.84,107.39a4.69,4.69,0,0,1,0-7.82L56.52,88.45,68,80.78a4.7,4.7,0,0,1,5.2,7.83L56.52,99.72l-5.63,3.76,5.63,3.75,16.69,11.12A4.7,4.7,0,0,1,75.3,122.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.3,122.26a4.69,4.69,0,0,1-2.09,3.91L56.52,137.29V126l5.64-3.76-5.64-3.76V107.23l16.69,11.12A4.7,4.7,0,0,1,75.3,122.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.21,88.61,56.52,99.72V88.45L68,80.78a4.7,4.7,0,0,1,5.2,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33,73.74H14.26A4.69,4.69,0,0,1,9.57,69V40.87a4.7,4.7,0,0,1,4.69-4.7H33a4.7,4.7,0,1,1,0,9.4H19V64.35H33a4.7,4.7,0,1,1,0,9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.61,152H42.43a4.69,4.69,0,0,1-4.69-4.7V78.43a4.7,4.7,0,0,1,9.39,0v64.18H65.91V78.43a4.7,4.7,0,0,1,9.39,0V147.3A4.69,4.69,0,0,1,70.61,152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.74,73.74H89.39a4.7,4.7,0,0,1,0-9.39H141V45.57H82.22a4.7,4.7,0,0,1,0-9.4h63.52a4.7,4.7,0,0,1,4.69,4.7V69A4.69,4.69,0,0,1,145.74,73.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.61,37.78a4.71,4.71,0,0,1-4.7-4.7V17.39H47.13V31.48a4.7,4.7,0,0,1-9.39,0V12.7A4.69,4.69,0,0,1,42.43,8H70.61a4.69,4.69,0,0,1,4.69,4.7V33.08A4.7,4.7,0,0,1,70.61,37.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.61,73.74a4.7,4.7,0,0,0-4.7,4.69v64.18H56.52V152H70.61a4.69,4.69,0,0,0,4.69-4.7V78.43A4.69,4.69,0,0,0,70.61,73.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.61,8H56.52v9.39h9.39V33.08a4.7,4.7,0,1,0,9.39,0V12.7A4.69,4.69,0,0,0,70.61,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.39,152H23.65a4.7,4.7,0,0,1,0-9.39H89.39a4.7,4.7,0,1,1,0,9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.39,142.61H56.52V152H89.39a4.7,4.7,0,1,0,0-9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.22,26.78H42.43A14.11,14.11,0,0,0,28.35,40.87V69A14.1,14.1,0,0,0,42.43,83.13H80A14.11,14.11,0,0,0,94.09,69V59.65A32.91,32.91,0,0,0,61.22,26.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.22,26.78h-4.7V83.13H80A14.11,14.11,0,0,0,94.09,69V59.65A32.91,32.91,0,0,0,61.22,26.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.09,59.65v4.7H51.83a4.69,4.69,0,0,1-4.7-4.7V26.78H61.22A32.91,32.91,0,0,1,94.09,59.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M61.22,26.78h-4.7V64.35H94.09v-4.7A32.91,32.91,0,0,0,61.22,26.78Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaBauvorhaben);
export default __webpack_public_path__ + "static/media/ka_bauvorhaben.9daa3fe795ad0b32aacbb8328d86a3fd.svg";
export { ForwardRef as ReactComponent };